import {isDesktop, isMobile, isTablet} from '../../../settings';
import {desktopErrorIcon} from '../../widgets/widgets';
import {changeLangToCurrent, getCurrentLang, getCurrentLangDirection} from '../../components/langSwitcher/langSwitcher';
import {createHtmlElement} from '../../../functions';
import {pageResize} from '../menu';
import {Cloudflare} from '../../api/Cloudflare';
import {BaseElement} from "../../interfaces/BaseElement";
import Swiper from "swiper";
import {EffectCube, Navigation, Pagination} from "swiper/modules";

const canvasClass = 'bmby-about-wrapp';
let aboutUsMainContainer;
let lang, dir, isData, activeTabInd, crmData;

export function aboutWidgetInit(parent) {
    lang = getCurrentLang();
    dir = getCurrentLangDirection();
    let crm = config.widgets.about;

    const customCss = config.crmProjectSettings.style?.about;
    if (Boolean(customCss)) {
        const styleElement = document.createElement('style');
        styleElement.textContent = customCss;
        document.head.appendChild(styleElement);
    }

    aboutUsMainContainer = new BaseElement()
        .addClass(`${canvasClass}`, `${dir}`, !isMobile ? 'background-backdrop-filter' : null)
        .appendTo(parent)
        .DOMElement;

    isData = checkCRM(crm);
    if (!isData) {
        showErrorPage();
        pageResize(aboutUsMainContainer);
        return;
    }

    crmData = crm.data;
    activeTabInd = isData ? crm.data[0].order : 0;

    insertMenu(activeTabInd, crm.data);
}

function cropImageToText() {
    if (window.innerWidth >= 1024) {
        const sectionCollection = document.querySelectorAll('.tab-content__container-section');
        sectionCollection.forEach(section => {
            setTimeout(() => {
                const img = section.querySelector('.about-us__img-container > .tab-content__image');
                const sub = section.querySelector('.text-content__wrapper > .about-us__sub-wrapper');
                let subHeight = 0;
                for (let child of sub.children) {
                    subHeight += child.getBoundingClientRect().height;
                }
                if (img.getBoundingClientRect().height > subHeight + 120) {
                    img.style.height = subHeight + 120 + 'px';
                }
            }, 50);
        });
    }
}

function insertMenu(activeTab = 0, data) {
    let tabsDataMainContainer;

    const menuWrapper = createHtmlElement(
        '',
        '',
        'div',
        ['menu-content__wrapper', 'widget-menu__content-wrapper']);
    const menuContainer = createHtmlElement(
        menuWrapper,
        '',
        'ul',
        ['about__menu__items', 'background-backdrop-filter', 'widget-menu__items']
    );
    aboutUsMainContainer.insertAdjacentElement('afterbegin', menuWrapper);

    const isTabWrapperExist = aboutUsMainContainer.querySelector('.tabs-data-content__wrapper');
    if (!isTabWrapperExist) {
        tabsDataMainContainer =
            createHtmlElement(
                aboutUsMainContainer,
                '',
                'div',
                ['tabs-data-content__wrapper', isMobile ? 'background-backdrop-filter' : null]
            );
    } else {
        tabsDataMainContainer = isTabWrapperExist;
    }

    if (getNonEmptyAmountOfTabs(data) <= 1)
        menuWrapper.classList.add('hidden');

    data.forEach((menuElement, index) => {
        if (menuElement.sections.length) {
            let chapter = menuElement.chapter.filter(el => el.lang === lang);
            if (!chapter[0].hasOwnProperty('value'))
                throw 'menuElement has unsupported structure';
            const li = createHtmlElement(menuContainer, chapter[0].value, 'li',
                [
                    'menu__item',
                    'text',
                    'body',
                    'widget-menu__item'
                ]);
            li.dataset.order = menuElement.order;
            if (index + 1 !== data.length) {
                createHtmlElement(menuContainer, '', 'li', ['widget-menu__separator']);
            }
            buildTabsContent(tabsDataMainContainer, menuElement, data);
        }
    });

    const menuElementOrder = document.querySelector('.menu__item[data-order="' + activeTab + '"]');
    switchTab(menuElementOrder);
    activeTabInd = activeTab;

    menuContainer.addEventListener('click', (e) => switchTab(e.target));
}

function getNonEmptyAmountOfTabs(data) {
    let amount = 0;
    data.forEach(category => {
        if (category.sections.length > 0)
            amount++;
    });
    return amount;
}

function buildTabsContent(container, objectContent, data) {
    const tab = new BaseElement()
        .addClass('tab-content__container')
        .appendTo(container);
    objectContent.sections.forEach(sectionData => {
        let section = new BaseElement()
            .addClass('tab-content__container-section')
            .appendTo(tab.DOMElement);
        tab.addAttribute('data-order', objectContent.order);

        const textWrapper = new BaseElement()
            .addClass('text-content__wrapper')
            .appendTo(section.DOMElement);
        const subWrapper = new BaseElement()
            .addClass('about-us__sub-wrapper')
            .appendTo(textWrapper.DOMElement);

        if (sectionData.title.filter(el => el.lang === lang)[0].value.length > 0)
            new BaseElement('h3')
                .addClass('tab-content__title', 'text', 'title-2')
                .innerHtml(sectionData.title.filter(el => el.lang === lang)[0].value)
                .appendTo(subWrapper.DOMElement);

        const currentSectionDescriptionText = sectionData.description.filter(el => el.lang === lang)[0].value;
        let translation = config.dictionary['AI'][getCurrentLang()];
        if (translation === '') {
            translation = config.dictionary['AI']['en'];
        }
        const textWithReplacedTemplate = currentSectionDescriptionText.replace(/{{AI}}/g, translation);

        new BaseElement('p')
            .addClass('tab-content__text', 'text', 'body')
            .innerHtml(textWithReplacedTemplate)
            .appendTo(subWrapper.DOMElement);

        const imgContainer = new BaseElement()
            .addClass('about-us__img-container')
            .appendTo(section.DOMElement);


        if (sectionData?.images.length > 1) {
            createCarousel(imgContainer.DOMElement, sectionData.images);
        }
		else if (sectionData?.images?.length === 1 || Boolean(sectionData?.imageUrl)) {
            const imageUrl = sectionData?.images?.length === 1 ? sectionData.images[0] : sectionData?.imageUrl;
            new BaseElement('img')
                .addClass('tab-content__image')
                .addAttribute('src', Cloudflare.resize(imageUrl, {
                    width: isDesktop ? 2048 : isMobile ? 512 : 1024,
                    quality: 75
                }))
                .appendTo(imgContainer.DOMElement);
        }

        if (objectContent.order !== 0) {
            if (data.length > 1)
                tab.addClass('hide-tab');
        }
    });
}

function createCarousel(parentContainer, arrayOfImages) {
    const swiperElement = new BaseElement()
        .addClass('swiper', 'about-image-carousel')
        .appendTo(parentContainer);
    const wrapperElement = new BaseElement()
        .addClass('about-image-carousel__wrapper', 'swiper-wrapper')
        .appendTo(swiperElement.DOMElement);

    arrayOfImages.forEach((picture, index) => {
        let url;

        if (isMobile || isTablet) {
            url = Cloudflare.resize(picture, {
                width: 1024,
                quality: 75
            });
        } else {
            url = Cloudflare.resize(picture, {
                width: 2048,
                quality: 75
            });
        }

        const imgContainer = new BaseElement()
            .addClass('about-image-carousel__image-container', 'swiper-slide')
            .appendTo(wrapperElement.DOMElement);

        new BaseElement('img')
            .addClass('about-image-carousel__image')
            .setAttributes({
                'src': url,
                'alt': `Picture-${index}`
            })
            .event('load', () => {
                preloaderContainer.remove()
            })
            .appendTo(imgContainer.DOMElement)

        const preloaderContainer = new BaseElement()
            .addClass('about-image-carousel__preloader')
            .appendTo(imgContainer.DOMElement);
        new BaseElement()
            .addClass('swiper-lazy-preloader', 'swiper-lazy-preloader-white')
            .appendTo(preloaderContainer.DOMElement);
    });

    new BaseElement()
        .addClass('about-image-carousel__pagination', 'swiper-pagination')
        .appendTo(swiperElement.DOMElement);
    new BaseElement()
        .addClass('about-image-carousel__navigation-btn', 'swiper-button-next', 'icon-right1')
        .appendTo(swiperElement.DOMElement);
    new BaseElement()
        .addClass('about-image-carousel__navigation-btn', 'swiper-button-prev', 'icon-left1')
        .appendTo(swiperElement.DOMElement);

    Swiper.use([Pagination, EffectCube, Navigation]);
    new Swiper('.about-image-carousel', {
        effect: 'fade',
        loop: arrayOfImages.length > 1,
        spaceBetween: 30,
        pagination: {
            el: '.about-image-carousel__pagination',
            type: 'bullets',
            clickable: true
        },
        navigation: {
            nextEl: ".about-image-carousel__navigation-btn.swiper-button-next",
            prevEl: ".about-image-carousel__navigation-btn.swiper-button-prev",
        },
    });
}

function toggleTabContent(tabOrder) {
    const tabsContentCollection = document.querySelectorAll('.tab-content__container');
    tabsContentCollection.forEach(tab => {
        if (tab.dataset.order === tabOrder) {
            tab.classList.remove('hide-tab');
        } else {
            tab.classList.add('hide-tab');
        }
    });
}

function switchTab(e) {
    if (e === null)
        return;

    const parent = e.parentElement;
    if (e.classList.contains('menu__item')) {
        setActiveTab(parent, e);
        activeTabInd = e.dataset.order;
        if (isMobile) {
            toggleTabContent(e.dataset.order);
            scrollToActiveTabContent(activeTabInd);
        } else {
            toggleTabContent(e.dataset.order);
            scrollToTheTop();
        }
    }
}

function setActiveTab(parent, e) {
    const menuItemsCollection = parent.querySelectorAll('.menu__item');
    menuItemsCollection.forEach(menu => {
        if (e === menu) {
            menu.classList.add('about-active', 'active');
        } else {
            menu.classList.remove('about-active', 'active');
        }
    });
}

const scrollToActiveTabContent = (activeTabInd) => {
    const contentWrapper = document.querySelector('.tabs-data-content__wrapper');
    const contentTab = contentWrapper.querySelector('.tab-content__container');
    const wrapperWidth = parseInt(getComputedStyle(contentWrapper).width);
    const tabWidth = parseInt(getComputedStyle(contentTab).width);
    const gapWidth = parseInt(getComputedStyle(contentWrapper).gap);
    const contentWidth = tabWidth;
    const centerAlignCorrection = (wrapperWidth - tabWidth) / 2;
    const offset = contentWidth * (activeTabInd - 1) - centerAlignCorrection + gapWidth * 1.5;

    contentWrapper.scroll({
        top: 0,
        left: offset,
        behavior: 'smooth'
    });
}

const scrollToTheTop = () => {
    const contentWrapper = document.querySelector('.tabs-data-content__wrapper');
    contentWrapper.scroll({
        top: 0,
        behavior: 'smooth'
    });
};

function checkCRM(crm) {
    if (crm.data.length) {
        const sections = crm.data.filter(el => el.sections.length);
        return !!sections.length;
    } else {
        return false;
    }
}

function showErrorPage() {
    const mainContainer = document.querySelector('.' + canvasClass);
    const wrapper = createHtmlElement(mainContainer, '', 'div', ['error-page__wrapper']);
    const icon = createHtmlElement(wrapper, '', 'div', ['error-page__icon']);
    icon.innerHTML = desktopErrorIcon;
    createHtmlElement(wrapper, 'The page is under construction', 'h1', ['error-page__title']);
}

export function updateAboutUsLanguage() {
    const popUp = document.querySelector('.pop-up-page.about-us');
    if (popUp) {
        const contentContainer = popUp.querySelector('.pop-up-page__content-body');
        const aboutContainer = popUp.querySelector(`.${canvasClass}`);
        aboutContainer.remove();
        aboutWidgetInit(contentContainer);
    }
}
